import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n";
import { SERVICES } from "../data/content";
import { GlowCard } from "../components/fx/GlowCard";
import { Icon } from "../components/Icon";
import { SectionHeading } from "../components/SectionHeading";
import { stagger, item } from "../components/fx/Reveal";

export const Services = () => {
  const { lang, L, ui } = useLang();
  return (
    <section className="relative bg-surface1/40 py-24 md:py-32">
      <div className="pointer-events-none absolute inset-0 dot-bg opacity-30" />
      <div className="container-pdr relative">
        <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-end">
          <SectionHeading
            label={lang === "ro" ? "Servicii principale" : "Core services"}
            title={lang === "ro" ? "Soluții complete, de la locuință la industrie." : "Complete solutions, from home to industry."}
          />
          <Link to="/contact" className="group hidden shrink-0 items-center gap-2 text-sm font-medium text-glow-2 md:inline-flex">
            {ui.common.requestQuote}
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4"
        >
          {SERVICES.map((s, i) => (
            <motion.div key={i} variants={item}>
              <GlowCard className="flex h-full flex-col" data-testid={`service-card-${i}`}>
                <div className="relative h-40 overflow-hidden rounded-t-2xl">
                  <img
                    src={s.image}
                    alt={L(s)?.title}
                    loading="lazy"
                    decoding="async"
                    className="h-full w-full object-cover transition-all duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-surface2 via-surface2/40 to-transparent" />
                  <div className="absolute left-4 top-4 flex h-11 w-11 items-center justify-center rounded-xl border border-glow-2/30 bg-ink/70 text-glow-2 backdrop-blur">
                    <Icon name={s.icon} className="h-5 w-5" />
                  </div>
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <h3 className="font-display text-lg font-bold leading-snug text-white">{L(s)?.title}</h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-white/55">{L(s)?.desc}</p>
                </div>
              </GlowCard>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
